import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, Save } from 'lucide-react';

/**
 * AutoSaveNotification - Minimal circular notification for automatic saves
 * Shows Save icon transforming to Check icon in bottom right corner
 */
const AutoSaveNotification = ({ isVisible }) => {
    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.5, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.5, y: 20 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                    className="fixed bottom-8 right-8 z-50"
                >
                    {/* Circular transparent container */}
                    <div className="relative">
                        {/* Background circle with transparency */}
                        <div className="bg-white/80 backdrop-blur-sm rounded-full p-4 shadow-lg border border-gray-200/50">
                            {/* Save icon (initial) */}
                            <motion.div
                                initial={{ opacity: 1, scale: 1 }}
                                animate={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.3, delay: 0.3 }}
                                className="absolute inset-0 flex items-center justify-center"
                            >
                                <Save size={24} className="text-blue-600" strokeWidth={2.5} />
                            </motion.div>

                            {/* Check icon (appears after save) */}
                            <motion.div
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.3, delay: 0.4, type: "spring", stiffness: 200 }}
                                className="flex items-center justify-center"
                            >
                                <Check size={24} className="text-green-600" strokeWidth={3} />
                            </motion.div>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default AutoSaveNotification;
